"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const DatePicker_1 = require("./DatePicker");
const DigitInput_1 = require("./DigitInput");
const Input_1 = require("./Input");
const Label_1 = require("./Label");
const NumberInput_1 = require("./NumberInput");
const Textarea_1 = require("./Textarea");
const Box_1 = require("../Box");
const FormElement = styled_1.default.form((props) => ({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    ...(0, Box_1.box)(props),
}));
const Form = (props) => {
    return (0, jsx_runtime_1.jsx)(FormElement, { ...props });
};
exports.Form = Form;
Form.DatePicker = DatePicker_1.DatePicker;
Form.Input = Input_1.Input;
Form.Label = Label_1.Label;
Form.NumberInput = NumberInput_1.NumberInput;
Form.DigitInput = DigitInput_1.DigitInput;
Form.Textarea = Textarea_1.Textarea;
